import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseCtl } from '@ncs/ncs-lib';
import { EventService } from '@ncs/ncs-lib';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { SharedataService } from '../common/service/sharedata.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent extends BaseCtl {
  @ViewChild('content') content: any;
  public authKey: string = '';

  public keySuffix: any;
  public appName: any;
  public orgName: any;

  public enableUserSignup: boolean = false;
  public rememberMe: boolean = false;
  public isreadonly = false;
  public showPassword: boolean = false;

  public applicationLogo: any = 0;
  public orgLogo: any = 0;
  private modalRef!: NgbModalRef;
  public rolelist = [];
  public loginByMobileNo: boolean = false;
  public loginByLoginCode: boolean = false;
  public loginByEmail: boolean = true;
  public loginByOptionsText: string = '';
  public loginPlaceholder: string = '';
  selectedRole: any;

  public applicationLoadError: boolean = false;
  public applicationErrorMessage: string = '';

  public applicationCode: string = '';
  public BASE_DOMAIN: any;
  constructor(
  public override locator: ServiceLocatorService,
  private eService: EventService,
  public override route: ActivatedRoute,
  private sharedata: SharedataService,
  private modalService: NgbModal,
  private router: Router,
) {
  super('', locator, route);

    const storedKeySuffix = localStorage.getItem('keySuffix');
    if (storedKeySuffix) {
    const currentAppId = this.getAppIdFromURL();
      if (currentAppId) {
        const storedAuthKey = localStorage.getItem(storedKeySuffix + 'cdAuthkey');
    if (storedAuthKey && storedAuthKey !== 'null' && storedAuthKey !== '-1') {
      const storedAppId = storedAuthKey.split('.')[1];
      if (storedAppId && storedAppId !== currentAppId) {
        console.warn(
              `Different app! Stored: ${storedAppId}, Current: ${currentAppId}. Clearing...`
        );
        localStorage.clear();
        window.location.reload();
        return;
      }
      if (storedAppId && storedAppId === currentAppId) {
          const userContext = localStorage.getItem(storedKeySuffix + 'userContext');
          const sessionId = localStorage.getItem(storedKeySuffix + 'sessionId');

        if (userContext && sessionId) {
          console.log('Already logged in, redirecting to dashboard...');
            router.navigateByUrl('/dashboard'); // 👈 change to your actual dashboard route
          return;
        }
      }
    }
      }
    }


  document.documentElement.setAttribute('class', 'light-theme');
  document.documentElement.style.setProperty('--primary-color', '#fff');
  document.documentElement.style.setProperty('--secondary-color', '#5f5f5f');

  let _self = this;

  // SUBDOMAIN
  const subdomainPromise = _self.locator.config
    .getProperty('SUBDOMAIN')
    .then((property: string) => {
      _self.BASE_DOMAIN = property;      
      _self.extractApplicationCodeFromURL();
    });

  //  CONTEXT_PATH + path variables
  const contextPathPromise = new Promise<void>((resolve) => {
    _self.locator.config
      .getProperty('CONTEXT_PATH')
      .then((property: string) => {
        _self.keySuffix = property + '-';
        _self.form.data['loginId'] = localStorage.getItem(_self.keySuffix + 'loginId');

        locator.getPathVariable(route, function (params: any) {
          _self.authKey = params['authKey'];
          if ('logout' === _self.authKey) {
            _self.logout();
          } else if ('session' === _self.authKey) {
            _self.sessionExpired();
          } else if (_self.authKey) {
            localStorage.setItem(_self.keySuffix + 'cdAuthkey', _self.authKey);
            let [orgId, appId] = _self.authKey.toString().split('.');
            _self.form.data['orgId'] = orgId;
            _self.form.data['id'] = appId;
          } else {
            let cdAuthkey = localStorage.getItem(_self.keySuffix + 'cdAuthkey');
            if (cdAuthkey !== null && cdAuthkey !== 'null') {
              let [orgId, appId] = cdAuthkey.toString().split('.');
              _self.form.data['orgId'] = orgId;
              _self.form.data['id'] = appId;
            } else {
              localStorage.setItem(_self.keySuffix + 'cdAuthkey', '-1');
  }
}
          resolve(); 
        });
      });
  });

  // Wait for BOTH before calling initLoginPage
  Promise.all([subdomainPromise, contextPathPromise]).then(() => {
    _self.initLoginPage();
  });

  // Independent - no dependency on above
  _self.locator.config
    .getProperty('endpoint.application')
    .then((property: string) => {
      _self.initApiEndpoint(property);
    });
}
  
extractApplicationCodeFromURL(): void {
  try {
  

    if (!this.BASE_DOMAIN) {
      console.warn('BASE_DOMAIN not configured yet');
      this.applicationCode = '';
      return;
    }
   

    const hostname = window.location.hostname;
    

    const baseDomain = this.BASE_DOMAIN.replace(/^\./, '');
 

    if (!hostname.endsWith(baseDomain)) {
     
      this.applicationCode = '';
      return;
    }

    const subdomainPart = hostname.substring(0, hostname.length - baseDomain.length);
   

    const cleanSubdomain = subdomainPart.replace(/\.$/, '');
   

    if (!cleanSubdomain || cleanSubdomain.toLowerCase() === 'apps') {
      this.applicationCode = '';
    } else {
      this.applicationCode = cleanSubdomain;
    }
   

  } catch (error) {
    console.error('Error extracting application code:', error);
    this.applicationCode = '';
  }
}
  /**
   * ngOnInit - session conflict ab constructor mein handle ho raha hai
   */
  override ngOnInit(): void {
    
  }

private initLoginPage(): void {
  let _self = this;
  _self.locator.config.getProperty('endpoint.login').then(() => {
  if (_self.applicationCode) {
    _self.GetApplicationDetailsByCode(_self.applicationCode);
  } else if (_self.form.data['id']) {
    _self.GetApplicationDetails(_self.form.data['id']);
  }
  if (_self.form.data['orgId']) {
    _self.getOrgDetails(_self.form.data['orgId']);
  }
  let uc = localStorage.getItem(_self.keySuffix + 'userContext');
  if (uc != null) {
    _self.locator.userContext = JSON.parse(uc);
  }
  });
}

  getAppIdFromURL(): string | null {
    try {
      const hash = window.location.hash;
      const loginPart = hash.split('/login/')[1];

      if (!loginPart || loginPart === 'logout' || loginPart === 'session') {
        return null;
      }

      const [orgId, appId] = loginPart.split('.');
      console.log(orgId, appId);
      return appId || null;
    } catch (e) {
      console.error('Error parsing URL:', e);
      return null;
    }
  }

  /**
   * populate form
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    super.populateForm(form, data);
    form.data.loginId = data.loginId;
    form.data.password = data.password;
  }

  /**
   * Login a user
   */
  public async login() {
    let _self = this;

    if (!_self.validateLoginId()) {
      _self.form.error = true;

      _self.form.message =
        'You can login by ' +
        (_self.loginByEmail ? 'Email / ' : '') +
        (_self.loginByMobileNo ? 'Mobile No / ' : '') +
        (_self.loginByLoginCode ? 'Login Code / ' : '');

      if (_self.form.message.endsWith(' / ')) {
        _self.form.message = _self.form.message.slice(0, -3);
      }

      return;
    }

    _self.locator.config
      .getProperty('endpoint.login')
      .then((property: string) => {
        let url = property + '/signin';
        this.locator.http.post(
          url,
          _self.form.data,
          async function (res: any, error: boolean) {
            if (error) {
              alert('Server Error:' + error);
              return;
            }

            _self.form.message = '';
            _self.form.inputerror = {};
            _self.form.error = !res.success;

            if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
              _self.form.message = res.result.message;
            }

            if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
              _self.form.inputerror = res.result.inputerror;
            }

            if (_self.locator.dataValidator.isTrue(res.success)) {
              let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
              localStorage.setItem('keySuffix', keySuffix);
              localStorage.setItem(keySuffix + 'loginId', res.result.data.loginId);
              localStorage.setItem(keySuffix + 'sessionId', res.result.jsessionid);
              localStorage.setItem(keySuffix + 'skey', res.result.data.skey);
              localStorage.setItem(keySuffix + 'appId', res.result.data.appId);
              localStorage.setItem(keySuffix + 'roleId', res.result.data.defaultRoleId);
              let str = JSON.stringify(res.result.data);
              localStorage.setItem(keySuffix + 'userContext', str);
              localStorage.setItem(keySuffix + 'theme', 'lightmode');
              await _self.getMenu(res.result.data.appId);
              _self.locator.userContext = JSON.parse(str);
            }
          },
        );
      });
  }

  validateLoginId(): boolean {
    const loginId = this.form.data['loginId'];

    const emailPattern = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/;
    const mobilePattern = /^\+?\d{8,15}$/;
    const codePattern = /^[A-Za-z0-9]{4,20}$/;

    const isEmail = emailPattern.test(loginId);
    const isMobile = mobilePattern.test(loginId);
    const isCode = codePattern.test(loginId);

    if (this.loginByEmail && isEmail) {
      console.log('Detected: Email');
      return true;
    }

    if (this.loginByMobileNo && isMobile) {
      console.log('Detected: Mobile No');
      return true;
    }

    if (this.loginByLoginCode && isCode) {
      console.log('Detected: Login Code');
      return true;
    }
    return false;
  }

  /**
   * Set selected role value
   * @param event
   */
  roleChange(event: any) {
    this.selectedRole = event.target.value;
  }

  /**
   * Select Role
   */
  selectRole() {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    localStorage.setItem(keySuffix + 'roleId', this.selectedRole);
    _self.eService.menuChanged('');
  }

  /**
   * Open model
   */
  async openModalFromTS(): Promise<void> {
    this.modalService.open(this.content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  /**
   * @param modal
   */
  closeModalFromTS(modal: NgbModalRef): void {
    modal.close('Closed by Select button');
    this.selectRole();
  }

  /**
   * @param modal
   */
  dismissModalFromTS(modal: NgbModalRef): void {
    modal.dismiss('Dismissed by Close button');
    this.logout();
  }

  /**
   * Get Application Role Menu
   * @param id
   * @param callback
   * @returns
   */
  async getMenu(id: number, callback?: any) {
    var _self = this;

    let searchData: any = {};
    if (!id || id == 0) {
      if (callback) {
        callback();
      }
      return;
    }
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let appId = localStorage.getItem(keySuffix + 'appId');
    searchData['applicationId'] = Number(appId);
    searchData['email'] = _self.form.data['loginId'];
    searchData['status'] = 'Accept';
    _self.resetForm();
    let url = _self.locator.config.get('endpoint.application.users') + '/search';

    _self.locator.http.post(
      url,
      searchData,
      async function (res: any, error: any) {
        if (error) {
          return;
        }

        _self.form.error = !res.success;
        _self.form.message = res.result.message;

        if (res.success) {
          _self.rolelist = res.result.data;
          if (_self.rolelist.length === 1) {
            _self.selectedRole = _self.rolelist[0]['applicationRoleId'];
            _self.selectRole();
          } else if (_self.rolelist.length > 0) {
            await _self.openModalFromTS();
          }
          if (callback) {
            callback();
          }
        }
      },
    );
  }

  /**
   * Forward to signup page
   */
  public signup() {
    this.forward('signup');
  }

  /**
   * Toggle password visibility
   */
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  /**
   * Logout a user
   */
  logout() {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let skey = localStorage.getItem(keySuffix + 'skey');

    let url = _self.locator.config.get('endpoint.login') + '/logout';
    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.clearLocalStorage();
      _self.locator.userContext = {};
      _self.eService.menuChanged('');

      const accessKey = localStorage.getItem(_self.keySuffix + 'cdAuthkey');
      if (accessKey !== null) {
        localStorage.setItem(_self.keySuffix + 'cdAuthkey', accessKey);
      }
      _self.locator.router.navigateByUrl('/login/' + accessKey);
      let [orgId, appId] = (accessKey ?? '').toString().split('.');
      _self.form.data['orgId'] = orgId;
      _self.form.data['id'] = appId;
    });
  }

  /**
   * Session Expired
   */
  sessionExpired() {
    let _self = this;
    _self.locator.userContext = {};
    _self.clearLocalStorage();
    const accessKey = localStorage.getItem(_self.keySuffix + 'cdAuthkey');
    if (accessKey !== null) {
      localStorage.setItem(_self.keySuffix + 'cdAuthkey', accessKey);
    }
    _self.locator.router.navigateByUrl('/login/' + accessKey);
    _self.form.error = true;
    _self.form.message = 'OOPS your session is expired';
    let [orgId, appId] = (accessKey ?? '').toString().split('.');
    _self.form.data['orgId'] = orgId;
    _self.form.data['id'] = appId;
  }

  /**
   * Clear Local Storage
   */
  clearLocalStorage() {
    let _self = this;

    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';

    localStorage.removeItem('keySuffix');
    localStorage.removeItem(keySuffix + 'loginId');
    localStorage.removeItem(keySuffix + 'sessionId');
    localStorage.removeItem(keySuffix + 'skey');
    localStorage.removeItem(keySuffix + 'appId');
    localStorage.removeItem(keySuffix + 'roleId');
    localStorage.removeItem(keySuffix + 'userContext');
    localStorage.removeItem(keySuffix + 'appLogoId');
    localStorage.removeItem(keySuffix + 'menuItems');
    localStorage.removeItem(keySuffix + 'reportMenu');
    localStorage.removeItem(keySuffix + 'theme');
    localStorage.removeItem(keySuffix + 'selectedSidebarColor');
    localStorage.removeItem(keySuffix + 'accessList');
    // localStorage.removeItem(keySuffix + 'cdAuthkey');
    localStorage.removeItem('uiform_listdata');
    localStorage.removeItem('userLanguage');
  }

  /**
   * Get Application Details by Code (subdomain)
   * @param code - The application code from subdomain
   */
  // GetApplicationDetailsByCode(code: string) {
  //   var _self = this;
  //   if (!code || code.trim() === '') {
  //     console.warn('No application code provided');
  //     return;
  //   }

  //   _self.locator.config
  //     .getProperty('endpoint.application')
  //     .then((property: string) => {
  //       let url = property + '/public/applicationDetailsByCode/' + code;
  //       this.locator.http.get(url, function (res: any, error: any) {
  //         if (error) {
  //           _self.applicationLoadError = true;
  //           _self.applicationErrorMessage = 'Failed to load application details. Server error occurred.';
  //           console.error('Server Error:' + error);
  //           return;
  //         }

  //         if (res.success && res.result && res.result.data) {
  //           // Store the application ID for future use
  //           if (res.result.data['id']) {
  //             _self.form.data['id'] = res.result.data['id'];
  //             // localStorage.setItem(_self.keySuffix + 'appId', res.result.data['id']);
  //           }

  //           // Store org ID if available
  //           if (res.result.data['orgId']) {
  //             _self.form.data['orgId'] = res.result.data['orgId'];
  //             // _self.getOrgDetails(res.result.data['orgId']);
  //           }

  //           // _self.applicationLogo = res.result.data['logo'];
  //           // _self.appName = res.result.data['name'];
  //           // _self.enableUserSignup = res.result.data?.enableUserSignup;
  //           // _self.loginByEmail = res.result.data?.loginByEmail;
  //           // _self.loginByMobileNo = res.result.data?.loginByMobileNo;
  //           // _self.loginByLoginCode = res.result.data?.loginByLoginCode;

  //           // Default to email if no login method is enabled
  //           // if (!_self.loginByEmail && !_self.loginByMobileNo && !_self.loginByLoginCode) {
  //           //   _self.loginByEmail = true;
  //           // }

  //         //   let loginMethods: string[] = [];
  //         //   if (_self.loginByEmail) loginMethods.push('Email');
  //         //   if (_self.loginByMobileNo) loginMethods.push('Mobile No');
  //         //   if (_self.loginByLoginCode) loginMethods.push('Login Code');
  //         //   _self.loginByOptionsText = 'You can login by ' + loginMethods.join(' / ');
  //         //   _self.loginPlaceholder = 'Enter your ' + loginMethods.join(' / ');
  //         // } else {
  //         //   _self.form.inputerror = {};
  //         //   _self.form.error = true;
  //         //   _self.applicationLoadError = true;
  //         //   _self.form.message = res.result?.message || 'Application not found or is inactive. Please contact support.';
  //         //   localStorage.removeItem(_self.keySuffix + 'cdAuthkey');
  //           // }

  //       });
  //     });
  // }

  GetApplicationDetailsByCode(code: string): void {
    if (!code || !code.trim()) {
      this.form.error = true;
      this.form.message = 'Application code is required';
      return;
    }

    this.locator.config
      .getProperty('endpoint.application')
      .then((baseUrl: string) => {
        const encodedCode = encodeURIComponent(code.trim());
        const url = `${baseUrl}/public/applicationDetailsByCode/${encodedCode}`;

        this.locator.http.get(url, (res: any, error: any) => {
          if (error) {
            this.applicationLoadError = true;
            this.form.error = true;
            this.form.message = 'Failed to load application details. Server error occurred.';
            console.error('Server Error:', error);
            return;
          }

          if (!res?.success || !res?.result?.data) {
            this.applicationLoadError = true;
            this.form.error = true;
            this.form.message = res?.result?.message || 'Application not found or inactive.';
            return;
          }

          const data = res.result.data;
          const appId = data.id;
          const orgId = data.orgId;

          if (!appId || !orgId) {
            console.error('Invalid response: Missing orgId or appId');
            this.form.error = true;
            this.form.message = 'Invalid application data received';
            this.applicationLoadError = true;
            return;
          }

          // Store data
          this.form.data['id'] = appId;
          this.form.data['orgId'] = orgId;

          // Build redirect URL
          const protocol = window.location.protocol;
          const port = window.location.port;
          const baseDomain = this.BASE_DOMAIN;
          const portPart = port ? `:${port}` : '';
          const baseOrigin = `${protocol}//${baseDomain.replace(/^\./, '')}${portPart}`;
          // const finalUrl = `${baseOrigin}/CD-APP/#/login/${orgId}.${appId}`;
          const finalUrl = `https://apps.ncsindore.com/#/login/${orgId}.${appId}`
          console.log('Redirecting to:', finalUrl);
          window.location.href = finalUrl;
        });
     
      })
      .catch((err: any) => {
        console.error('Config load failed:', err);
        this.form.error = true;
        this.form.message = 'Failed to load configuration';
        this.applicationLoadError = true;
      });
  }
  /**
   * Get Application Details (by ID - fallback method)
   */
  GetApplicationDetails(id: any) {
    var _self = this;
    if (!id || id == -1) {
      return;
    }
    _self.locator.config
      .getProperty('endpoint.application')
      .then((property: string) => {
        let url = property + '/public/applicationDetails/' + id;
        this.locator.http.get(url, function (res: any, error: any) {
          if (error) {
            _self.applicationLoadError = true;
            _self.applicationErrorMessage =
              'Failed to load application details. Server error occurred.';
            console.error('Server Error:' + error);
            return;
          }

          if (res.success) {
            _self.applicationLogo = res.result.data['logo'];
            _self.appName = res.result.data['name'];
            _self.enableUserSignup = res.result.data?.enableUserSignup;
            _self.loginByEmail = res.result.data?.loginByEmail;
            _self.loginByMobileNo = res.result.data?.loginByMobileNo;
            _self.loginByLoginCode = res.result.data?.loginByLoginCode;

            if (
              !_self.loginByEmail &&
              !_self.loginByMobileNo &&
              !_self.loginByLoginCode
            ) {
              _self.loginByEmail = true;
            }

            let loginMethods: string[] = [];
            if (_self.loginByEmail) loginMethods.push('Email');
            if (_self.loginByMobileNo) loginMethods.push('Mobile No');
            if (_self.loginByLoginCode) loginMethods.push('Login Code');
            _self.loginByOptionsText =
              'You can login by ' + loginMethods.join(' / ');
            _self.loginPlaceholder = 'Enter your ' + loginMethods.join(' / ');
          } else {
            _self.form.inputerror = {};
            _self.form.error = true;
            _self.applicationLoadError = true;
            _self.form.message =
              res.result?.message ||
              'Application not found or is inactive. Please contact support.';
            localStorage.removeItem(_self.keySuffix + 'cdAuthkey');
          }
        });
      });
  }

  /**
   * Get Org Details
   */
  getOrgDetails(id: any) {
    var _self = this;
    if (!id || id == -1) {
      return;
    }
    _self.locator.config
      .getProperty('endpoint.orgnization')
      .then((property: string) => {
        let url = property + '/public/orgDetails/' + id;
        this.locator.http.get(url, function (res: any, error: any) {
          if (error) {
            console.error('Server Error:' + error);
            return;
          }
          if (res.success) {
            _self.orgLogo = res.result.data['logoId'];
            _self.orgName = res.result.data['name'];
          }
        });
      });
  }
}
